export default "__VITE_ASSET__sELaNf_c__"